/* Fuego & Fragancia — recalcula las fechas del envío en el navegador.

   POR QUÉ, SI LIQUID YA LAS PINTA
   Dos cosas que el servidor no puede resolver:

     1. Shopify cachea las páginas. Una fecha calculada al renderizar puede
        servirse al día siguiente diciendo "hoy es ayer". Aquí es literal: la
        primera estación muestra la fecha de HOY, y equivocarse en eso hace que
        todo el bloque pierda credibilidad.
     2. El servidor no sabe en qué huso horario está quien mira. A las 23:00 en
        Bogotá el servidor puede estar ya en el día siguiente.

   Los nombres de los meses SÍ se localizan por idioma. No es lo mismo que el
   dinero: "20 ago" y "Aug 20" son la misma fecha bien escrita en cada idioma,
   mientras que "31,31 US$" y "$31.31" eran dos precios distintos. Por eso aquí
   sí se usa `toLocaleDateString` con el idioma de la página.

   Si algo falla, se quedan las fechas del servidor: son correctas el día que se
   generaron y nunca se ve un hueco. */

if (!customElements.get('ff-shipping')) {
  customElements.define(
    'ff-shipping',
    class FfShipping extends HTMLElement {
      connectedCallback() {
        try {
          this.pintar();
        } catch (e) {
          /* se quedan las del servidor */
        }
      }

      pintar() {
        var dias = function (el, clave, respaldo) {
          var n = parseInt(el.dataset[clave], 10);
          return isNaN(n) ? respaldo : n;
        };

        var envio = dias(this, 'daysShip', 1);
        var min = dias(this, 'daysMin', 3);
        var max = dias(this, 'daysMax', 5);
        var union = this.dataset.rangeJoin || '—';

        /* DÍAS HÁBILES, NO DE CALENDARIO.

           Sumar días a secas daba «pedido el sábado, enviado el domingo», y se
           comía los festivos. Aquí se avanza un día cada vez y solo cuentan los
           laborables de Estados Unidos: lunes a viernes, sin los festivos
           federales que llegan en `data-holidays` desde los ajustes del tema.

           La misma cuenta se hace en Liquid; esta la repite en el navegador
           porque Shopify cachea las páginas y la fecha del servidor puede
           llegar caducada. */
        var feriados = (this.dataset.holidays || '').split(',');

        var dosCifras = function (n) {
          return n < 10 ? '0' + n : '' + n;
        };

        var esHabil = function (d) {
          var dia = d.getDay();
          if (dia === 0 || dia === 6) return false;
          var iso = d.getFullYear() + '-' + dosCifras(d.getMonth() + 1) + '-' + dosCifras(d.getDate());
          return feriados.indexOf(iso) === -1;
        };

        var sumarHabiles = function (n) {
          var d = new Date();
          var contados = 0;
          var vueltas = 0;
          // El tope es una red de seguridad: una lista de festivos absurda no
          // puede dejar esto girando para siempre.
          while (contados < n && vueltas < 120) {
            d.setDate(d.getDate() + 1);
            vueltas += 1;
            if (esHabil(d)) contados += 1;
          }
          return d;
        };

        var idioma = document.documentElement.lang || 'en';
        var opciones = { month: 'short', day: 'numeric' };

        var texto = function (d) {
          return d.toLocaleDateString(idioma, opciones);
        };

        // El pedido se hace HOY, aunque hoy sea sábado: encargar se puede
        // cualquier día. Lo que se cuenta en hábiles es lo que viene después.
        this.escribir('order', texto(new Date()));
        this.escribir('ship', texto(sumarHabiles(envio)));
        this.escribir('delivery', texto(sumarHabiles(min)) + ' ' + union + ' ' + texto(sumarHabiles(max)));
      }

      escribir(clave, texto) {
        var el = this.querySelector('[data-date="' + clave + '"]');
        if (el) el.textContent = texto;
      }
    }
  );
}
